import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import Heading, { HeadingType } from "../atoms/Heading";

export type CentreCtaSectionPropType = {
  title: HeadingType;
  description: string;
  ctas: CtaType[];
  gradient?: boolean;
  maxWidth?: "max-w-[400px]" | "max-w-[720px]";
};

type DescriptionType = {
  text: string;
  href?: string;
}[];

const CentreCtaSection = ({
  title,
  description,
  ctas,
  gradient = false,
  maxWidth = "max-w-[400px]",
}: CentreCtaSectionPropType) => {
  // const renderDescription = () => {
  //   return description.map(({ text, href }, index) => {
  //     const trimmedText = text.trim(); // Trim the text
  //     const space = index < description.length - 1 ? " " : ""; // Add space if not the last element

  //     return (
  //       <Fragment key={text}>
  //         {href ? (
  //           <Link
  //             href={href}
  //             className="text-purple-3"
  //             // className={classNames(, {
  //             //   "sm:text-display-64B":
  //             //     fontStyle === "text-title-32 sm:text-display-64",
  //             // })}
  //           >
  //             {trimmedText}
  //           </Link>
  //         ) : (
  //           <span>{trimmedText}</span>
  //         )}
  //         {space && <span>{space}</span>}
  //       </Fragment>
  //     );
  //   });
  // };
  return (
    <div
      className={`relative w-full overflow-hidden ${
        gradient ? "bg-aurora1" : "bg-purple-0"
      } py-4 sm:py-12`}
    >
      {/* <BgSectionGradientGridLeft className="pointer-events-none absolute left-0 top-0 -z-0 opacity-50 mix-blend-multiply backdrop-filter" />
      <BgSectionGradientGridRight className="pointer-events-none absolute bottom-0 right-0 -z-0 opacity-50 mix-blend-multiply backdrop-filter" /> */}
      <div className="container flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center gap-2">
          <Heading
            heading={title}
            fontStyle="text-title-20 sm:text-title-32"
            as="h3"
          />
          <p className={`${maxWidth} text-center text-body-14 text-grey-4`}>
            {/* {renderDescription()} */}
            {description}
          </p>
        </div>

        <CtaButtonGroup ctas={ctas} />
      </div>
    </div>
  );
};

export default CentreCtaSection;
